(function () {
  'use strict';
  angular.module('vcconsult')
    .component('openconsultlist', {
      restrict: 'E',
      bindings: {},
      template: `
        <div class="alert alert-info"  ng-show="vm.openconsults.length === 0">Keine offenen Konsultationen</div>
        <div ng-repeat="oc in vm.openconsults" ng-show="vm.openconsults.length > 0">
          <a ui-sref="patientrecord.current({patientid: oc.patientid, clientid: oc.patientid, mode: 'patient'})">
            <span class="pull-left"><img class="img-responsive" style="max-width: 80px" ng-src="{{oc.patimage}}"></span>
            <h4  style="padding-left: 1em; margin-left: 1em">&nbsp;{{oc.patfirstname}} {{oc.patlastname}}</h4>
            <span class="clearfix"></span>
          </a>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService',
        function ($log, Consult, Rlog, vertxEventBusService) {
          let vm = this;

          vm.$onInit = function () {
            Consult.$search({open: true, active: true}).$then(function (oc) {
              vm.openconsults = oc;
            }, function (err) {
              $log.error('Loading list of open consults failed: ', err);
              Rlog.error('vcconsult', 'openconsultlist', 'Loading list of open consults failed', {});
            });
          }; // $onInit()


          // listen for consult updates
          vertxEventBusService.on('consults.update', function (message) {
            if (angular.isDefined(vm.openconsults) && angular.isDefined(vm.openconsults.$refresh)) {
              vm.openconsults.$refresh().$then(function () {
                $log.debug('Loading list of open consults succeeded: ', message);
              }, function (err) {
                $log.error('Loading list of open consults failed: ', err);
                Rlog.error('vcconsult', 'openconsultlist', 'refreshing list of open consults failed', {});
              });
            }
          });
        }
      ] // controller
    }); // component

// klammerfriedhof
}());
